import {
  Center,
  CloseButton,
  // Divider,
  Flex,
  StylesProvider,
  Tag,
  TagCloseButton,
  TagLabel,
  useMultiStyleConfig,
  Icon,
  useStyles,
  Box,
  // useTheme,
} from '@chakra-ui/react';
import { components as selectComponents } from 'react-select';

import { IconArrowFillDown } from 'assets/icons';

const ChakraComponents = {
  // Control components
  Control: ({
    children,
    innerRef,
    innerProps,
    isDisabled,
    isFocused,
    selectProps: { size, variant, fontSize },
  }: any) => {
    const inputStyles = useMultiStyleConfig('Input', { size, variant });

    const heights: any = {
      sm: 8,
      md: 10,
      lg: 12,
    };

    return (
      <StylesProvider value={inputStyles}>
        <Flex
          className="valueContainerWrapper"
          ref={innerRef}
          sx={{
            ...inputStyles.field,
            border: '1px',
            borderColor: 'inherit',
            p: 0,
            overflow: 'hidden',
            h: 'auto',
            minH: heights[size],
            fontSize: fontSize,
            bg: 'white',
          }}
          {...innerProps}
          {...(isFocused && { 'data-focus': true })}
          {...(isDisabled && { disabled: true })}
        >
          {children}
        </Flex>
      </StylesProvider>
    );
  },
  // MultiValue: ({ index, getValue, maxToShow = 3, ...props }: any) => {
  //   const overflow = getValue()
  //     .slice(maxToShow)
  //     .map((x: any) => x.label);

  //   const label = `+ ${overflow.length} item${overflow.length !== 1 ? 's' : ''}`;

  //   return index < maxToShow ? (
  //     <selectComponents.MultiValue {...props} />
  //   ) : index === maxToShow ? (
  //     <Tag variant="outline" size="md">
  //       {label}
  //     </Tag>
  //   ) : null;
  // },
  MultiValueContainer: ({ children, innerRef, innerProps, data, selectProps }: any) => (
    <Tag
      ref={innerRef}
      {...innerProps}
      m="0.125rem"
      // react-select Fixed Options example: https://react-select.com/home#fixed-options
      bg="gray.500"
      variant={data.isFixed ? 'solid' : 'subtle'}
      colorScheme={data.colorScheme || selectProps.colorScheme}
      size={selectProps.size}
      fontWeight="600"
      fontSize={selectProps.fontSize}
      px="2"
    >
      {children}
    </Tag>
  ),
  MultiValueLabel: ({ children, innerRef, innerProps }: any) => (
    <TagLabel ref={innerRef} {...innerProps} color="gray.500">
      {children}
    </TagLabel>
  ),
  MultiValueRemove: ({ children, innerRef, innerProps, data: { isFixed } }: any) => {
    if (isFixed) {
      return null;
    }

    return (
      <TagCloseButton ref={innerRef} {...innerProps} tabIndex={-1}>
        {children}
      </TagCloseButton>
    );
  },
  IndicatorSeparator: () => null,
  ClearIndicator: ({ innerProps, selectProps: { size } }: any) => {
    const iconSize: any = {
      sm: 'sm',
      md: 'sm',
      lg: 'md',
    };

    return <CloseButton {...innerProps} size={iconSize[size]} ml={2} tabIndex={-1} />;
  },
  DropdownIndicator: ({ innerProps, selectProps: { size, dropDownIconColor, dropDownIconOpacity } }: any) => {
    const { addon } = useStyles();

    const padding: any = {
      sm: 1,
      md: 3,
      lg: 3,
    };

    const iconSize: any = {
      sm: '8px',
      md: '10px',
      lg: 'sm',
    };

    return (
      <Center
        {...innerProps}
        sx={{
          ...addon,
          h: '100%',
          borderRadius: 0,
          borderWidth: 0,
          cursor: 'pointer',
          paddingX: padding[size],
          background: 'inherit',
        }}
      >
        <Icon
          as={IconArrowFillDown}
          fontSize={iconSize[size]}
          sx={{
            path: {
              fill: dropDownIconColor ?? '#5A687A',
              fillOpacity: dropDownIconOpacity ?? 0.5,
            },
          }}
        />
      </Center>
    );
  },
  // Menu components
  Menu: ({ children, ...props }: any) => {
    const menuStyles = useMultiStyleConfig('Menu', {});
    return (
      <selectComponents.Menu {...props}>
        <StylesProvider value={menuStyles}>{children}</StylesProvider>
      </selectComponents.Menu>
    );
  },
  // MenuList: ({ innerRef, children, maxHeight, selectProps: { size } }: any) => {
  //   const { list } = useStyles();
  //   const chakraTheme = useTheme();

  //   const borderRadii: any = {
  //     sm: chakraTheme.radii.sm,
  //     md: chakraTheme.radii.md,
  //     lg: chakraTheme.radii.md,
  //   };

  //   return (
  //     <Box
  //       sx={{
  //         ...list,
  //         maxH: `${maxHeight}px`,
  //         overflowY: 'auto',
  //         borderRadius: borderRadii[size],
  //       }}
  //       ref={innerRef}
  //     >
  //       {children}
  //     </Box>
  //   );
  // },
  GroupHeading: ({ innerProps, children }: any) => {
    const { groupTitle } = useStyles();
    return (
      <Box sx={groupTitle} {...innerProps}>
        {children}
      </Box>
    );
  },
  Option: ({
    innerRef,
    innerProps,
    children,
    isFocused,
    isDisabled,
    isSelected,
    selectProps: { fontSize, hasCheckbox },
  }: any) => {
    const { item } = useStyles();
    return hasCheckbox ? (
      <Box
        role="button"
        sx={{
          ...item,
          w: '100%',
          textAlign: 'left',
          // @ts-ignore
          bg: isFocused ? item._focus.bg : 'transparent',
          fontSize: fontSize,
          // @ts-ignore
          ...(isDisabled && item._disabled),
        }}
        ref={innerRef}
        {...innerProps}
        {...(isDisabled && { disabled: true })}
        display="flex"
        alignItems="center"
        gridGap="2"
      >
        <input type="checkbox" checked={isSelected} onChange={() => null} /> <label>{children}</label>
      </Box>
    ) : (
      <Box
        role="button"
        sx={{
          ...item,
          w: '100%',
          textAlign: 'left',
          // @ts-ignore
          bg: isFocused ? item._focus.bg : 'transparent',
          fontSize: fontSize,
          // @ts-ignore
          ...(isDisabled && item._disabled),
        }}
        ref={innerRef}
        {...innerProps}
        {...(isDisabled && { disabled: true })}
      >
        {children}
      </Box>
    );
  },
};

export default ChakraComponents;
